import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import Key from "../../../clientVariables.json";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { userSelector } from "../../user-redux/selector";
import {
  getJobTypesAction,
  resetCandidatesAction,
} from "../../redux/action";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { myCandidatesSelector } from "../redux/selector";
import { getCandidateDetailAction } from "../redux/action";

const CandidatePersonalDetailsForm = ({
  formDataHnadler,
  candidatesRefreshHandler,
}) => {
  const dispatch = useDispatch();
  const { jobTypesList } = useSelector(appSelector);
  const { candidateDetails } = useSelector(myCandidatesSelector);

  const { user } = useSelector(userSelector);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    dob: null,
    gender: "",
    experience: "",
    educationLevels: "",
    jobTitle: "",
    jobType: "",
    jobTypeID: "",
    currentSalary: "",
    expectedSalary: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    dispatch(getJobTypesAction());
  }, [dispatch]);

  useEffect(() => {
    const fetch = async () => {
      if (candidateDetails?.candidate_id) {
        try {
          const jobTypeName = await jobTypesList.filter(
            (item) => item.id === parseInt(candidateDetails?.jobtype_id)
          );

          await setFormData({
            firstName: candidateDetails?.first_name
              ? candidateDetails?.first_name
              : "",
            lastName: candidateDetails?.last_name
              ? candidateDetails?.last_name
              : "",
            email: candidateDetails?.email ? candidateDetails?.email : "",
            contactNumber:
              candidateDetails?.phone !== undefined &&
              candidateDetails?.phone !== null &&
              candidateDetails?.phone !== "undefined"
                ? candidateDetails?.phone
                : "",
            dob:
              candidateDetails?.date_of_birth !== undefined &&
              candidateDetails?.date_of_birth !== null &&
              candidateDetails?.date_of_birth !== "undefined" &&
              candidateDetails?.date_of_birth !== "0000-00-00 00:00:00"
                ? candidateDetails?.date_of_birth
                : null,
            gender: candidateDetails?.gender ? candidateDetails?.gender : "",
            experience: candidateDetails?.work_experience
              ? candidateDetails?.work_experience
              : "",
            educationLevels: "",
            jobTitle:
              candidateDetails?.role !== undefined &&
              candidateDetails?.role !== null &&
              candidateDetails?.role !== "undefined" &&
              candidateDetails?.role !== ""
                ? candidateDetails?.role
                : "",
            jobType:
              candidateDetails?.jobtype !== undefined &&
              candidateDetails?.jobtype !== null &&
              candidateDetails?.jobtype !== "undefined" &&
              candidateDetails?.jobtype !== ""
                ? candidateDetails?.jobtype
                : "",
            jobTypeID:
              candidateDetails?.jobtype_id !== undefined &&
              candidateDetails?.jobtype_id !== null &&
              candidateDetails?.jobtype_id !== "undefined" &&
              candidateDetails?.jobtype_id !== ""
                ? candidateDetails?.jobtype_id
                : "",
            currentSalary:
              candidateDetails?.current_salary !== undefined &&
              candidateDetails?.current_salary !== null &&
              candidateDetails?.current_salary !== "undefined" &&
              candidateDetails?.current_salary !== ""
                ? candidateDetails?.current_salary
                : "",
            expectedSalary:
              candidateDetails?.desired_salary !== undefined &&
              candidateDetails?.desired_salary !== null &&
              candidateDetails?.desired_salary !== "undefined" &&
              candidateDetails?.desired_salary !== ""
                ? candidateDetails?.desired_salary
                : "",
          });
          await formDataHnadler(formData, "f1");
        } catch (error) {
          console.error(error);
        }
      }
    };
    fetch();
  }, [candidateDetails]);

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      dob: moment(date).format("MM-DD-YYYY"),
    });
  };

  const handleJobTypeChange = (event) => {
    const selectedJobType = event.target.value;
    const filterName = event.target.name;
    setFormData({
      ...formData,
      jobType: filterName,
      jobTypeID: selectedJobType,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    formDataHnadler(formData, "f1");

    console.log(candidateDetails);
    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/personal/${candidateDetails?.candidate_id}`,
        {
          userid: user?.id,
          firstname: formData.firstName,
          lastname: formData.lastName,
          email: formData.email,
          phone: formData.contactNumber,
          date_of_birth: formData.dob,
          gender: formData.gender,
          experience: formData.experience,
          jobtitle: formData.jobTitle,
          jobtype: formData.jobType,
          jobtypeid: formData.jobTypeID,
          // current_salary: formData.currentSalary,
          // expected_salary: formData.expectedSalary,
        }
      );

      if (response.data.data.msg === "Updated Successfully") {
        dispatch(getCandidateDetailAction(candidateDetails?.candidate_id, user?.id));

        handleOpenSnackbar("candidate personal details updated", "success");
        await candidatesRefreshHandler();
      } else {
        handleOpenSnackbar("Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      // handleOpenSnackbar("something went wrong888", "error");
    }
    setIsSubmitting(false);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;

    // Clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        title={
          <Typography variant="h6" sx={headerStyles}>
            Update Personal Details
          </Typography>
        }
      />
      <CardContent
        sx={{
          ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
          ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
          ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
            { padding: "8px 6px" },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  First Name
                </Typography>
                <TextField
                  id="firstName"
                  label=""
                  variant="outlined"
                  placeholder="Jacob"
                  value={formData.firstName}
                  onChange={handleInputChange("firstName")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Last Name
                </Typography>
                <TextField
                  id="lastName"
                  label=""
                  variant="outlined"
                  placeholder="Jones"
                  value={formData.lastName}
                  onChange={handleInputChange("lastName")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Email
                </Typography>
                <TextField
                  id="email"
                  label=""
                  variant="outlined"
                  placeholder="James@gmail.com"
                  value={formData.email}
                  onChange={handleInputChange("email")}
                  sx={inputStyles}
                  disabled
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              {/* <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Contact number
                </Typography>
                <TextField
                  id="contactNumber"
                  label=""
                  variant="outlined"
                  placeholder="01-789123654"
                  value={formData.contactNumber}
                  onChange={handleInputChange("contactNumber")}
                  sx={inputStyles}
                />
              </FormControl> */}
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Contact number
                </Typography>
                <TextField
                  id="contactNumber"
                  label=""
                  variant="outlined"
                  placeholder="(xxx) xxx-xxxx"
                  value={formatPhoneNumber(formData.contactNumber)}
                  onChange={handleInputChange("contactNumber")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              dateLibInstance={moment}
            >
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography paragraph sx={labelStyles}>
                    Date Of Birth
                  </Typography>
                  <DatePicker
                    sx={inputStyles}
                    value={
                      formData.dob ? moment(formData.dob, "MM/DD/YYYY") : null
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="MM/DD/YYYY"
                        sx={inputStyles}
                      />
                    )}
                    onChange={handleDateChange}
                    maxDate={moment().endOf("year")}
                  />
                </FormControl>
              </Grid>
            </LocalizationProvider>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Gender
                </Typography>
                <Select
                  id="gender"
                  label=""
                  variant="outlined"
                  value={formData.gender}
                  onChange={handleInputChange("gender")}
                  sx={inputStyles}
                >
                  <MenuItem value="">Select Gender</MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                Gender
                </Typography>
                <TextField
                  id="gender"
                  label=""
                  variant="outlined"
                  placeholder="Male/Female"
                  value={formData.gender}
                  onChange={handleInputChange("gender")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid> */}
            {/* <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph>
                  Date Of Birth
                </Typography>
                <DatePicker
                  id="dob"
                  label="Date Of Birth"
                  value={formData.dob}
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="MM/DD/YYYY"
                    />
                  )}
                />
              </FormControl>
            </Grid> */}
            {/* <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Bio
                </Typography>
                <TextField
                  id="bio"
                  label=""
                  multiline
                  minRows={4}
                  variant="outlined"
                  placeholder="Bio"
                  value={formData.bio}
                  onChange={handleInputChange("bio")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid> */}
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Experience
                </Typography>
                <TextField
                  id="experience"
                  label=""
                  variant="outlined"
                  placeholder="1-3 years"
                  value={formData.experience}
                  onChange={handleInputChange("experience")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Education Levels
                </Typography>
                <TextField
                  id="educationLevels"
                  label=""
                  variant="outlined"
                  placeholder="Certificate"
                  value={formData.educationLevels}
                  onChange={handleInputChange("educationLevels")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Job Title
                </Typography>
                <TextField
                  id="jobTitle"
                  label=""
                  variant="outlined"
                  placeholder="Web Developer"
                  value={formData.jobTitle}
                  onChange={handleInputChange("jobTitle")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Job Type
                </Typography>
                <Select
                  labelId="jobType-label"
                  id="jobType"
                  label=""
                  placeholder="Job Type"
                  value={formData.jobTypeID}
                  name={formData.jobType}
                  onChange={handleJobTypeChange}
                  sx={inputStyles}
                >
                  <MenuItem value="" disabled>
                    Select Job Type
                  </MenuItem>
                  {jobTypesList?.map((jobType, index) => (
                    <MenuItem
                      key={index}
                      value={jobType.id}
                      name={jobType.title}
                    >
                      {jobType.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Current Salary($)
                </Typography>
                <TextField
                  id="currentSalary"
                  label=""
                  variant="outlined"
                  placeholder="$2500"
                  value={formData.currentSalary}
                  onChange={handleInputChange("currentSalary")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Expected Salary($)
                </Typography>
                <TextField
                  id="expectedSalary"
                  label=""
                  variant="outlined"
                  placeholder="$3500"
                  value={formData.expectedSalary}
                  onChange={handleInputChange("expectedSalary")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid> */}

            <Grid item xs={12} textAlign="end">
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#406882" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Card>
  );
};

export default CandidatePersonalDetailsForm;

const cardStyles = {
  boxShadow: "none",
  borderRadius: "8px",
};

const headerStyles = {
  color: "rgb(102, 120, 156)",
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
